import { render, staticRenderFns } from "./budget-categories.vue?vue&type=template&id=b3cb1b92"
import script from "./budget-categories.vue?vue&type=script&lang=js"
export * from "./budget-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports